module.exports = __webpack_public_path__ + "img/1561903211.01e71c0d.jpg";